import { Modal } from "antd";
import { useMemo } from "react";
import { PlayerForm } from "./PlayerForm";

const MODAL_MODE_EDIT = "edit";
const MODAL_MODE_CREATE = "create";

const MODAL_TITLES = {
  [MODAL_MODE_CREATE]: "Add Player",
  [MODAL_MODE_EDIT]: "Edit Player",
};

export const PlayerDialog = ({
  open,
  onCancel,
  playerData = null,
  onSubmit,
}) => {
  const mode = useMemo(
    () => (playerData ? MODAL_MODE_EDIT : MODAL_MODE_CREATE),
    [playerData]
  );

  const modalTitle = useMemo(() => MODAL_TITLES[mode], [mode]);

  return (
    <Modal
      open={open}
      title={modalTitle}
      onCancel={onCancel}
      footer={null}
    >
      <PlayerForm
        defaultValue={playerData}
        onSubmit={onSubmit}
        onCancel={onCancel}
      />
    </Modal>
  );
};
